import _ from 'lodash'
import user from 'scoreboard/components/user'
import alertMetadata from './alert-metadata'

const alertHelper = {

	/**
	 * gather up the data from a raw AlertsResponse sent from the server into data
	 * keyed by DomainType and ID to allow for efficiently working with the data in JavaScript
	 */
	dataByIdByDomainType(data) {
		const keys = _.keys(this.metadataPropertyByDomainType)
		const byType = {}
		_.forEach(keys, k => {
			const property = this.metadataPropertyByDomainType[k]
			byType[k] = _.keyBy(data[property], 'id')
		})

		// organization and user are both duplicated because some code uses
		// the plural name, and some uses the domain type code (singular),
		// and this code is scattered all over the place. I decided it'd
		// be less error prone to just have the duplication
		byType.organization = byType.organizations
		byType.user = byType.users

		return byType
	},

	metadataPropertyByDomainType: {
		'scorecard-item': 'scorecardItems',
		initiative: 'initiatives',
		dashboard: 'dashboards',
		'strategy-map': 'strategyMaps',
		report: 'reports',
		briefing: 'briefings',
		file: 'files',
		dataset: 'datasets',
		calendar: 'calendars',
		organizations: 'organizations',
		users: 'users',
		chart: 'charts',
		form: 'forms'
	},

	/**
	 *
	 * @param {Subscription[]} subscriptions
	 * @param {alertMetadata.types} type The alert rule type to look for
	 *
	 * @return {boolean} true if the current user exists as the owningPrincipal of one or more
	 * of the provided subscriptions
	 */
	userSubscribed(subscriptions, type) {
		return _.some(subscriptions, s => {
			return ownedByCurrentUser(s) && type === s.type
		})
	},

	/**
	 * Prepares principals from a list of subscriptions for display.
	 *
	 * @param subscriptions
	 * @return {
	 *     currentUserSubscribed: Number?
	 *     otherSubscribers: [Principal]
	 * }
	 */
	getPublishChangesSubscribers(subscriptions) {
		const group = {
			currentUserSubscribed: undefined,
			otherSubscribers: []
		}
		_.reduce(subscriptions, (acc,s) => {
			const {id, owningPrincipal} = s
			if (s.type == alertMetadata.types.CHANGE_PUBLISHED) {
				if (ownedByCurrentUser(s)) {
					group.currentUserSubscribed = id
				} else {
					group.otherSubscribers.push(_.extend({subscriptionId: id}, owningPrincipal))
				}
			}
			return group
		},group)
		return group
	}

}

/** If the subscription is owned by the current user */
const ownedByCurrentUser = subscription => {
	const {id, type} = subscription.owningPrincipal
	return type === 'user' && id == user.model.id
}

export default alertHelper

alertHelper.__filename__ = 'alerts/alert-helper.js'
